import React, { useEffect, useRef, useState } from 'react';
import { CategoriesTab, Category, getRandomizedTabs } from './MainAvatar';
import { UpdateUserTraits, UploadUserTraits, useGetAllReferral } from './hooks/helper';
import { useNavigate } from 'react-router-dom';

type Fragment = {
  id: number;
  style: React.CSSProperties & {
    '--tx': string;
    '--ty': string;
    '--rot': string;
  };
};

interface Props {
  onClose: () => void;
}

const LootAnimationModal: React.FC<Props> = ({ onClose }) => {
  const [animationState, setAnimationState] = useState('initial');  
  const [fragments, setFragments] = useState<Fragment[]>([]);
  const [showReset, setShowReset] = useState(false);


    const { data } = useGetAllReferral();
    const navigate = useNavigate();
    const userdetails = data?.user ?? null;
  
  
    const [tabs, setTabs] = useState<Category[]>(getRandomizedTabs);

     

      useEffect(() => {
        if (
          userdetails &&
          (!userdetails.traits || userdetails.traits.length === 0) &&
          !userdetails.pfp
        ) {
          const randomized = getRandomizedTabs();
          const formattedTabs = randomized.map((tab) => ({
            label: tab.label,
            availableItem: tab.availableItem?.[0] || null,
          }));
          UploadUserTraits(formattedTabs);
          console.log("generate new basic trait");
          setTabs(randomized);
          
        }
      }, [userdetails]);
      


      useEffect(() => {
        let traits = userdetails?.traits;
      
        if (typeof traits === "string") {
          try {
            traits = JSON.parse(traits);
          } catch (e) {
            traits = [];
          }
        }
      
        if (traits && traits.length > 1 && traits.length < 3) {
          const randomized = getRandomizedTabs();
          const formattedTabs = randomized.map((tab) => ({
            label: tab.label,
            availableItem: tab.availableItem?.[0] || null,
          }));
          UpdateUserTraits(formattedTabs);
          console.log("Add new basic trait");
          setTabs(randomized);
        }
      }, [userdetails]);
      
      


// generate and add new basic trait
 

    
  const generateFragments = (): Fragment[] => {
    const colors = ['#ff3e3e', '#ff9f3e', '#ffe03e', '#3eff5e', '#3ebaff', '#a53eff'];
    const newFragments: Fragment[] = [];

    for (let i = 0; i < 40; i++) {
      const tx = (Math.random() - 0.5) * 1000;
      const ty = (Math.random() - 0.5) * 1000;
      const rot = Math.random() * 720 - 360;
      const size = Math.random() * 40 + 10;

      newFragments.push({
        id: i,
        style: {
          '--tx': `${tx}px`,
          '--ty': `${ty}px`,
          '--rot': `${rot}deg`,
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: colors[Math.floor(Math.random() * colors.length)],
          left: `calc(50% - ${size / 2}px)`,
          top: `calc(50% - ${size / 2}px)`,
        }
      });
    }

    return newFragments;
  };

  const startAnimation = () => {
    if (animationState !== 'initial') return;
    setAnimationState('shaking');

    setTimeout(() => {
      setAnimationState('exploded');
      setFragments(generateFragments());

      setTimeout(() => setShowReset(true), 1500);
    }, 800);
  };

  const resetAnimation = () => {
    setAnimationState('initial');
    setFragments([]);
    setShowReset(false);
  };

  useEffect(() => {
    const timer = setTimeout(startAnimation, 300);
    return () => clearTimeout(timer);
  }, []);


    useEffect(() => {
      if (userdetails && (!userdetails.traits || !userdetails.pfp)) {
        setTabs(getRandomizedTabs());
      }
    }, [userdetails?.traits, userdetails?.pfp]);
  
    
  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
      <div className="relative w-full h-full flex items-center justify-center overflow-hidden">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 text-white text-xl bg-gray-800 bg-opacity-70 px-4 py-1 rounded-full hover:bg-opacity-100"
        >
          ✕
        </button>

        {/* Lootbox */}
        {animationState !== 'exploded' && (
          <div 
            className={`relative z-10 transform transition-all ${animationState === 'shaking' ? 'shake' : ''}`}
            onClick={startAnimation}
          >
            <img 
              src="/assets/main_v4/lootbox/box.png" 
              alt="Purple Box" 
              className="w-[500px] h-[500px] object-contain"
            />
          </div>
        )}

        {/* Explosion fragments */}
        {fragments.map(fragment => (
          <div 
            key={fragment.id}
            className="explode-fragment absolute"
            style={fragment.style as React.CSSProperties}
          />
        ))}

       
      </div>
    </div>
  );
};

export default LootAnimationModal;